<div v-if="options" >
    <p>{{ $t('vm.components.popin.create-colleague.text1') }}</p>
    <details-colleague :colleague="options" :submitted="submitted"/>
</div>
